<template>
	<LabeledFieldLayout
		class="labeled-team-drop-down"
		:is-valid="isValid"
	>
		<TeamDropDown
			:disabled="disabled"
			:options="options"
			:value="value"
			:is-valid="isValid"
			v-on="bubble(
				`opening`,
				`opened`,
				`closing`,
				`closed`,
				`change`
			)"
		/>
	</LabeledFieldLayout>
</template>

<script>
import EventsMixin from "../../mixins/EventsMixin";
import LabeledFieldLayout from "./LabeledFieldLayout";
import TeamDropDown from "../TeamDropDown";

export default {
	name: "LabeledTeamDropDown",
	mixins: [ EventsMixin, ],
	emits: [
		"change",
		"closed",
		"closing",
		"opened",
		"opening",
	],
	components: {
		LabeledFieldLayout,
		TeamDropDown,
	},

	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { text: String, value: String, mark: String, }, ... ] **/
		options: {
			type: Array,
			required: true,
		},
		value: {
			type: String,
			required: true,
		},
		isValid: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.labeled-team-drop-down {
	.teaming-drop-down {
		width: 100%;
	}
}
</style>
